import createHyphenator from 'hyphen';
import { DocumentLanguageModule } from './document-language.module';

/*
	From jaarbeurs-front-end
	@author Erik Vroon
*/
export class HyphenationModule {
	constructor() {
		this.hyphenationSelector = '.hyphenate, h1, h2, h3, .h1, .h2, .h3';
		this.minimumWordLength = 12;
		this._root = document;
	}
	setRoot(root) {
		this._root = root;
	}
	getRoot() {
		this._root;
	}
	setMinimumWordLength(minimumWordLength) {
		this.minimumWordLength = minimumWordLength;
		// console.log('set setMinimumWordLength to', minimumWordLength);
	}
	initialize() {
		let documentLanguageModule = new DocumentLanguageModule();
		let language = documentLanguageModule.getLanguageFromDocument();
		
		if (language && typeof this._root !== 'undefined') {
			// console.log('got language from document...', language);
			let hyphenateThese = this._root.querySelectorAll(this.hyphenationSelector);
			// console.log('hyphenateThese', hyphenateThese);
			// console.log('hyphenateThese', hyphenateThese);
			let minimumWordLength = this.minimumWordLength;
			if (hyphenateThese) {
				this.hyphenate(hyphenateThese, language, this.minimumWordLength);
			}
		}
	}

	hyphenate(hyphenateThese, language, minimumWordLength) {
		// console.log('hyphenate called, with language', language,' and min word length', minimumWordLength);
		switch (language.substr(0, 2)) {
			case 'nl':
				import('hyphen/patterns/nl').then(patterns => {
					// https://www.ksharifbd.com/blog/exploring-ES2020-dynamic-import/
					this.handleLanguagePatterns(patterns, hyphenateThese, minimumWordLength);
				});
				break;
			case 'en': // en-GB, en-US... etc. We assume British English, as it is the best English ;)
				import('hyphen/patterns/en-gb').then(patterns => {
					this.handleLanguagePatterns(patterns, hyphenateThese, minimumWordLength);
				});
				break;
		}

	}

	handleLanguagePatterns(patterns, hyphenateThese, minimumWordLength) {
		const hyphenator = createHyphenator(patterns, {
			async: false,
			html: true,
			minWordLength: minimumWordLength,
		});
		hyphenateThese.forEach((hyphenateThis) => {
			this.handleHyphenationElement(hyphenateThis, hyphenator, patterns);
		});
	}

	handleHyphenationElement(hyphenateThis, hyphenator, patterns) {
		let minimumWordLength = this.minimumWordLength; // default
		if (hyphenateThis.dataset && hyphenateThis.dataset.minimumWordLength) {
			// override hyphenator, create a new one specially for this word length
			minimumWordLength = hyphenateThis.dataset.minimumWordLength;
			hyphenator = createHyphenator(patterns, {
				async: false,
				html: true,
				minWordLength: minimumWordLength,
			});
			// console.log('specific minimum word length requested', hyphenateThis.dataset.minimumWordLength);
			// if the element of which the content is to be hyphenated has data-minimum-word-length
		}
		let hyphenated = hyphenator(hyphenateThis.innerHTML);
		// console.log('hyphenated result would be', hyphenated);
		hyphenateThis.innerHTML = hyphenated;
	}
}